var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cursor-pointer" }, [
    _vm.item.readed
      ? _c(
          "div",
          {
            staticClass: "d-flex p-2",
            style: {
              background: "#F5F7F6",
              color: "#666666",
            },
          },
          [
            _c(
              "div",
              {
                style: {
                  width: _vm.mobile ? "100px" : "",
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.dateFormat(_vm.item.createdAt)) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ms-4" }, [
              _vm._v(" " + _vm._s(_vm.item.title) + "\n    "),
            ]),
          ]
        )
      : _c("div", { staticClass: "d-flex p-2" }, [
          _c(
            "div",
            {
              style: {
                width: _vm.mobile ? "100px" : "",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.dateFormat(_vm.item.createdAt)) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-blue ms-4 font-bold" }, [
            _vm._v(" " + _vm._s(_vm.item.title) + "\n    "),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }